export default "__VITE_ASSET__DNjcpACj__"